export default __webpack_public_path__ + "static/media/arrow-up.15355e70.svg";